import { MarketOdd, OutcomeDto } from '@bz/request/src/apis';

export enum BetSlipType {
  Single = 'SINGLE',
  Combo = 'COMBO',
  System = 'SYSTEM',
}

export enum SingleSubType {
  CustomBet = 'CUSTOM', //属于single 类型的子类型
  Outright = 'OUTRIGHT',
  Single = 'SINGLE',
}

export enum ComboType {
  TwoOfThree = '2/3',
  ThreeOfFour = '3/4',
  FourOfFive = '4/5',
  Trixie = 'Trixie',
  Yankee = 'Yankee',
}

export const ComboTypeBetsCount: Record<ComboType, string> = {
  [ComboType.TwoOfThree]: `(3${t('Bets')})`,
  [ComboType.ThreeOfFour]: `(4${t('Bets')})`,
  [ComboType.FourOfFive]: `(5${t('Bets')})`,
  [ComboType.Trixie]: `(4${t('Bets')})`,
  [ComboType.Yankee]: `(11${t('Bets')})`,
};

type Extra = {
  marketStatus?: number;
  phase?: number;
};

type CombinedMarket = MarketOdd & OutcomeDto & Extra;

type BaseOdds = Pick<CombinedMarket, 'code' | 'outcomeId' | 'outcomeName' | 'odds' | 'active' | 'marketStatus'>;

export type Simplify<T> = { [K in keyof T]: T[K] } & {};
export type Odds = Simplify<BaseOdds & { matchId: string }>;

export type OddsExtra = {
  uniqueKey: string;
  amount: number;
  betChanged?: boolean;
  marketName?: string;
  colName?: string;
  marketTabType?: string;
  marketId?: string;
  specifiers?: string;
  type: SingleSubType; // custom bet 还是冠军盘 还是普通single
  copyNo?: string;
  copyType?: number;
  selections: SimpleOdds[];
};

export type SimpleOdds = Simplify<Odds & OddsExtra>;

export const enum OddsSettings {
  ACCEPT_ANY_ODDS_CHANGE = 0,
  ACCEPT_HIGHER_ODDS_CHANGE = 2,
  ACCEPT_NOTHING_ODDS_CHANGE = 1,
}

export enum BetStatus {
  NORMAL = 'normal',
  LOADING = 'loading',
  SUCCESS = 'success',
  PartialSuccess = 'partialSuccess',
}

// for betslip overlay
export enum BetslipStatus {
  LOADING = 'loading',
  SUCCESS = 'success',
  EMPTY = 'empty',

  ERROR = 'error',
  SERVER_ERROR = 'server error',

  NETWORK_ERROR = 'network_error',
  TIMEOUT = 'timeout',
  MBS_REPORT_AILED = 'mbs_report_failed',

  // 业务
  // 全部下注失败时 金额过小 10001
  BET_AMOUNT_TOO_SMALL = 'bet_amount_too_small',
  // 全部下注失败时 金额过大 10002
  BET_AMOUNT_TOO_LARGE = 'bet_amount_too_large',
  // 最大下注数50个 10003
  BET_MAX_COUNT = 'bet_max_count',

  SINGLE_ODDS_CHANGE = 'single_odds_change',

  // 部分成功 且错误码大于等于两个 10009
  SINGLE_PARTIALLY_PLACED = 'single_partially_placed',
  // 部分成功 赔率变化 部分成功 10012
  SINGLE_ODDS_PARTIALLY_PLACED = 'single_odds_partially_placed',
  // 部分成功 赔率变化 全部失败 10013
  SINGLE_ODDS_ALL_FAILED = 'single_odds_all_failed',
  // 全部下注失败（且错误码大于等于两个） 10017
  ALL_BET_FAILED = 'all_bet_failed',

  COMBO_ODDS_CHANGE = 'combo_odds_change',
  COMBO_BALANCE_INSUFFICIENT = 'combo_balance_insufficient',
  COMBO_MARKET_UNAVAILABLE = 'combo_market_unavailable',
}

type BetSelection = {
  matchId: string;
  marketName: string;
  colName?: string; //有特殊盘口的列名，如tot盘口 home/away 3.5， 中的home/away
  outcome: SimpleOdds;
};

export interface OddsDataParams extends BetSelection {
  /** 盘口ID 必填 */
  marketId: string;
  comboType?: ComboType;
}

export type BetInput = {
  amount: string | number;
  matchId?: string;
  code?: string;
  betType?: BetSlipType;
};
